import { useState } from "react";
import {
  Collapse,
  List,
  ListItem,
  ListSubheader,
  Typography,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { SentTo } from "../../../app/backendTypes";
import { tsToDate } from "../../../app/utils";
import ExpandMore from "../ExpandMore";

function ApprovalNotificationList(props: { history: SentTo[] }) {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <List
      subheader={
        <ListSubheader
          sx={{ bgcolor: "inherit", display: "flex" }}
          disableGutters
        >
          Notifications
          <ExpandMore expand={expanded} onClick={handleExpandClick}>
            <ExpandMoreIcon fontSize="small" color="disabled" />
          </ExpandMore>
        </ListSubheader>
      }
    >
      <Collapse in={expanded} timeout="auto">
        {props.history.map((entry, index) => {
          const date = tsToDate(entry.ts);

          return (
            <ListItem key={index} disablePadding>
              <Typography variant="caption" color="text.secondary">
                <Typography
                  component="span"
                  variant="caption"
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {entry.sent_to}
                </Typography>
                <br />
                {`${date.toDateString()} at ${date.toLocaleTimeString()}`}
              </Typography>
            </ListItem>
          );
        })}
      </Collapse>
    </List>
  );
}

export default ApprovalNotificationList;
